import { Card } from '@zorro/design-system/v2/Card';
import { Grid, Text } from '@zorro/web/design-system';
import { useMonolithQuery } from '@zorro/web/ui-utils';

export type MajorMedicalCombinedPlanCardProps = {
  onboardingPeriodId?: string;
};

export const MajorMedicalCombinedPlanCard = ({
  onboardingPeriodId,
}: MajorMedicalCombinedPlanCardProps) => {
  const { data: benefits, isLoading } = useMonolithQuery({
    method: 'benefitsControllerGetBenefits',
    params: onboardingPeriodId && [onboardingPeriodId],
  });

  const plan = benefits?.majorMedicalBenefit?.plan;
  if (!plan || isLoading) {
    return null;
  }

  const { isCombinedPlan, extendedPlanDetails } = plan;
  if (!isCombinedPlan || !extendedPlanDetails) {
    return null;
  }

  return (
    <Card variant="white-border" style={{ borderColor: '#D9DBDF' }}>
      <Grid align="center">
        <Grid.Col span={{ base: 12, md: 3.4 }}>
          <Text fw={600}>Combined plan info</Text>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 8 }}>
          <Text>{extendedPlanDetails}</Text>
        </Grid.Col>
      </Grid>
    </Card>
  );
};
